export default "__VITE_ASSET__DgB7FbjS__"